import { IProbability } from "@/@types/campaign-roulette";

export const transformProbabilitiesToPercentage = (probabilities: IProbability[]): IProbability[] => {
  let converted = probabilities.map(prob => {
    const probValue = prob.prob;
    const safeProb = (probValue === null || probValue === undefined || isNaN(probValue)) ? 0 : probValue;
    return {
      ...prob,
      prob: Math.round(safeProb * 10000) / 100
    };
  });
  
  if (converted.length === 0) {
    converted = Array(6).fill(null).map(() => ({ prob: 0, prizes: [] }));
  } else if (converted.length < 6) {
    const remaining = 6 - converted.length;
    const emptyProbs = Array(remaining).fill(null).map(() => ({ prob: 0, prizes: [] }));
    converted = [...converted, ...emptyProbs];
  } else if (converted.length > 6) {
    converted = converted.slice(0, 6);
  }
  
  const total = converted.reduce((sum, p) => {
    const prob = p.prob;
    return sum + ((prob === null || prob === undefined || isNaN(prob)) ? 0 : prob);
  }, 0);
  const diff = 100 - total;
  
  if (Math.abs(diff) > 0.01 && total > 0) {
    const maxIndex = converted.reduce((maxIdx, curr, idx, arr) => 
      curr.prob > arr[maxIdx].prob ? idx : maxIdx, 0
    );
    converted[maxIndex].prob = Math.round((converted[maxIndex].prob + diff) * 100) / 100;
  }
  
  return converted;
};
